<ng-decking-boards-environment *ngIf="step === 1 && !isLoading"></ng-decking-boards-environment>
<ng-decking-boards-decking-boards-configuration *ngIf="step === 2"></ng-decking-boards-decking-boards-configuration>
<ng-decking-boards-finishes *ngIf="step === 3"></ng-decking-boards-finishes>
<ng-decking-boards-accessories *ngIf="step === 4"></ng-decking-boards-accessories>
<ng-decking-boards-summary *ngIf="step === 5"></ng-decking-boards-summary>
